<template>
  <div class="va-json-input" :class="{ 'va-json-input__error': jsonFormatError }">
    <div class="d-flex align-center">
      <span class="va-json-input__label">{{ label }} </span>
      <CopyText class="ml-auto" :value="formJson" display-icon></CopyText>
    </div>
    <code-input
      :key="jsonInputKey"
      v-model="formJson"
      :title="''"
      :mode="'application/json'"
      :options="{ scrollbarStyle: 'null' }"></code-input>
    <div v-if="jsonFormatError" class="va-json-input__error-message">Invalid JSON format!</div>
  </div>
</template>

<script>
  import CodeInput from "@/components/custom/CodeInput";
  import CopyText from "@/components/custom/CopyText";

  export default {
    name: "JsonInput",
    components: {
      CodeInput,
      CopyText,
    },
    props: {
      value: {
        type: Object,
        default: () => ({}),
      },
      label: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        jsonInputKey: 0,
        /**
         * When editing JSON input (code-input), user might make the JSON inside of the code-input invalid;
         * jsonFormatError is true if JSON format inside of the code-input is incorrect (not parseable using JSON.parse)
         */
        jsonFormatError: false,
      };
    },
    computed: {
      formJson: {
        get() {
          return JSON.stringify(this.value, null, " ");
        },
        set(value) {
          let parsedJson;
          try {
            this.jsonFormatError = false;
            parsedJson = JSON.parse(value);
          } catch (e) {
            this.jsonFormatError = true;
          }

          if (!this.jsonFormatError) {
            this.emitValue(parsedJson);
          }
        },
      },
    },
    methods: {
      emitValue(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      },
    },
  };
</script>
<style scoped lang="scss">
  @import "@/@core/preset/preset/functions.scss";
  @import "@/@core/preset/preset/typography/index.scss";

  .va-json-input {
    &::v-deep {
      .va-code-input__label-wrapper {
        margin-bottom: 0;
      }
    }
    &__label {
      @include text-caption-bold();
      color: get-color("subtitle");
    }
    &__error-message {
      @include text-caption();
      color: get-color("error");
    }
    &::v-deep {
      .vue-codemirror {
        resize: vertical;
        overflow: auto !important;
        background: #272822;
        height: 58px;
        border-radius: 5px;
        .CodeMirror {
          height: calc(100% - 10px) !important;
        }
      }
    }
  }
</style>
